import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BzgModalService, BzgToastService, BzgToastType } from 'bz-genome-angular';
import { I18nService } from 'i18n/i18n.service';
import { TimezoneService } from './services/timezone.service';
import { ITimeZoneList } from './interfaces/ITimeZoneList';
import { ResetConfirmationComponent } from 'app/shared/components/reset-confirmation/reset-confirmation.component';
import { Router } from '@angular/router';

@Component({
  selector: 'biz-timezone',
  templateUrl: './timezone.component.html',
  styleUrls: ['./timezone.component.scss']
})
export class TimezoneComponent implements OnInit {
  public listTimezone: ITimeZoneList[];
  public currentTimeZone: ITimeZoneList;
  public showLoading: boolean = true;
  public selectedValue: string = '';
  private _showTimeZoneRegion: boolean = false;

  get showTimeZoneRegion(): boolean {
    return this._showTimeZoneRegion;
  }

  constructor(
    public timeZoneService: TimezoneService,
    private _i18nService: I18nService,
    private _modalService: BzgModalService,
    private _toastService: BzgToastService,
    private _translateService: TranslateService,
    private _router: Router) {
  }

  ngOnInit(): void {
    this.timeZoneService.showTimeZoneRegion().subscribe((data) => {
      this._showTimeZoneRegion = data;
    });
    this.getTimeZonesList();
  }

  getSelectedValue(): string {
    if (!this.currentTimeZone) return '';
    
    return this._showTimeZoneRegion ? this.currentTimeZone.Id : this.currentTimeZone.TimeZoneOffset;
  }

  getOptionValue(itemTimezone: ITimeZoneList): string {
    return this._showTimeZoneRegion ? itemTimezone.Id : itemTimezone.TimeZoneOffset;
  }

  getTimeZonesList() {
    this.timeZoneService.getTimeZonesList().subscribe((response) => {
      if (response) {
        this.listTimezone = response;
        this.getCurrentTimeZone();
      }
      else
        this.listTimezone = [];
    });
  }

  getCurrentTimeZone() {
    this.timeZoneService.getTimeZoneConfiguration().subscribe((response) => {
      if (response) {
        this.currentTimeZone = response;
        this.selectedValue = this.getSelectedValue();
      } else {
        this.currentTimeZone = null;
        this.selectedValue = '';
      }
      this.showLoading = false;
    });
  }

  onSave() {
    const title = this._i18nService.instant('TIMEZONE.MODAL_TITLE_SAVE');
    const message = this._i18nService.instant('TIMEZONE.MODAL_MESSAGE_SAVE');
    const modal = this._modalService.open(ResetConfirmationComponent, {
      closeOnBackdropClick: false,
      closeOnRouterNavigation: true,
      data: { title, message, button: 'GLOBAL.SAVE' }
    });
    modal.afterClosed().subscribe((result) => {
      if (result === 'reset') {
        this.onSaveService();
      }
    });
  }

  onSaveService() {
    this.showLoading = true;
    
    // Find the selected timezone based on the current selection mode
    if (this._showTimeZoneRegion) {
      this.currentTimeZone = this.listTimezone.find(x => x.Id === this.selectedValue);
    } else {
      // Match by TimeZoneOffset when region is not shown
      this.currentTimeZone = this.listTimezone.find(x => x.TimeZoneOffset === this.selectedValue);
    }
    this.timeZoneService.saveEnvironmentTimeZone(this.currentTimeZone).subscribe(
      () => {
        this.showToast(this._i18nService.instant('GLOBAL.THE_OPERATION_WAS_SAVED_SUCCESSFULLY'), 'success');
        this.getCurrentTimeZone();
        setTimeout(() => {
          this.reloadCurrentView();
        }, 1000);
      },
      (error) => {
        this.showToast(this._i18nService.instant('GLOBAL.AN_ERROR_HAS_OCCURRED'), 'error');
        this.showLoading = false;
      }
    );
  }

  showToast(messageInput: string, type: BzgToastType) {
    this._toastService.open(
      messageInput,
      {
        type,
        duration: 5000,
        verticalPosition: 'bottom',
        horizontalPosition: 'right'
      });
  }

  reloadCurrentView() {
    sessionStorage.setItem('realoadView', 'true');
  }
}
